export function imageReformat(url) {
  return url + (url.includes('?') ? '&' : '?') + 'code=' + (window.localStorage.getItem('code') || '');
}
